export class CreateBookingV3Endpoint {}
